// src/components/Dashboard.jsx
import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import CREGrid from "./CREGrid";
import DealTeamWorkspace from "./DealTeamWorkspace";

const Dashboard = ({ userId }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [mountedTabs, setMountedTabs] = useState([true, false]);

  const handleTabChange = (_, value) => {
    setActiveTab(value);
    setMountedTabs((current) => current[value]
      ? current
      : current.map((mounted, index) => mounted || index === value));
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <Tabs value={activeTab} onChange={handleTabChange}>
        <Tab label="Loan Portfolio" />
        <Tab label="Deal Team" />
      </Tabs>
      <Box sx={{ flex: 1, minHeight: 0, position: "relative" }}>
        {mountedTabs[0] && (
          <Box
            role="tabpanel"
            hidden={activeTab !== 0}
            sx={{ height: "100%" }}
          >
            <CREGrid userId={userId} />
          </Box>
        )}
        {mountedTabs[1] && (
          <Box
            role="tabpanel"
            hidden={activeTab !== 1}
            sx={{ height: "100%" }}
          >
            <DealTeamWorkspace userId={userId} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Dashboard;
